import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { http, PHONE } from "../lib/api";
import { useCart } from "../lib/cart";

const Shell = ({ children, testid }) => (
  <main data-testid={testid} className="mx-auto flex min-h-[80vh] max-w-2xl flex-col items-center justify-center px-4 pt-24 text-center">{children}</main>
);

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { clear } = useCart();
  const clearRef = useRef(clear);
  clearRef.current = clear;
  const [state, setState] = useState("checking");
  const sid = params.get("session_id");

  useEffect(() => {
    if (!sid) { setState("error"); return undefined; }
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await http.get(`/payments/status/${sid}`);
        if (data?.payment_status === "paid") { setState("paid"); clearRef.current(); return; }
        if (data?.status === "expired") { setState("error"); return; }
      } catch { /* keep polling */ }
      if (++tries < 10) timer = setTimeout(poll, 2000); else setState("pending");
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid]);

  return (
    <Shell testid="payment-success-page">
      {state === "checking" && <><Loader2 className="h-10 w-10 animate-spin text-[#E11D48]" /><p className="mt-6 text-slate-300">Confirming your payment...</p></>}
      {state === "paid" && (
        <>
          <CheckCircle2 className="h-14 w-14 text-emerald-400" />
          <h1 data-testid="payment-success-title" className="mt-6 font-display text-6xl font-black uppercase">Order confirmed</h1>
          <p className="mt-4 text-slate-300">Thank you. We'll be in touch about delivery. Questions? Call or WhatsApp {PHONE}.</p>
        </>
      )}
      {(state === "pending" || state === "error") && (
        <>
          <h1 className="font-display text-5xl font-black uppercase">Payment not confirmed yet</h1>
          <p className="mt-4 text-slate-300">If you were charged, contact us on {PHONE} and we'll sort it.</p>
        </>
      )}
      <Link to="/shop" data-testid="payment-continue-link" className="mt-10 rounded-full bg-white px-8 py-4 font-semibold text-[#090D12]">Continue shopping</Link>
    </Shell>
  );
}

export function PaymentCancel() {
  return (
    <Shell testid="payment-cancel-page">
      <XCircle className="h-14 w-14 text-[#E11D48]" />
      <h1 className="mt-6 font-display text-6xl font-black uppercase">Checkout cancelled</h1>
      <p className="mt-4 text-slate-300">No payment was taken. Your basket is still saved.</p>
      <Link to="/shop" data-testid="payment-back-link" className="mt-10 rounded-full bg-white px-8 py-4 font-semibold text-[#090D12]">Back to shop</Link>
    </Shell>
  );
}
